////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { filter } from 'lodash'
import { bindActionCreators } from 'redux'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import Modals from '../../../../components/Modals'
import Button from '../../../../components/Ui/Buttons'
import theme from '../../../../theme/theme'
import { TextModal } from '../../../../theme/GlobalCss'
import StringFormatter from '../../../../helpers/StringFormatter'
import { articleLifeManagerActionCreators } from '../../../../store/actions'
/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'
import Cancel from '../../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModalDeleteWrapper = styled.div``
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const TextTopWrapper = styled.div`
	margin: 15px 0;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalWrapperBottom = styled(TextModalWrapper)`
	margin-bottom: 15px;
	display: flex;
	justify-content: flex-start;
`
const TextModalCustom = styled.div`
	padding: 0;
`
const TextModalRed = styled(TextModal)`
	color: ${(props) => props.theme.colors.error};
	font-weight: 900;
`
/////////STYLED/////////
//[63]_i): ACTIVATE ITEM

const ModalDelete = (props) => {
	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())
	const id = props.active.item.header.id
	let query = ''
	if (filter(props.active.item.header.actionsOnItem, (elem) => elem.query === 'Active')) {
		query = 'Active'
	}

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleActiveItem = () => {
		actionsArticleLifeManager.postActiveItem(id, query)
		props.active.close()
	}

	const concat = `<span style="color: ${theme.colors.primary}" > [${props.active.item.header.itemRefLabel}] </span>`
	let text = StringFormatter.ResponseMessageParser(translations['modal__itemRef__timeline_action_activation_now_message_firstPart'], [concat])

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.active.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalDeleteWrapper>
			<Modals
				showModal={props.active.show}
				closeModalHandler={props.active.close}
				title={translations['modal__itemRef__timeline_action_activation_now_title']}
				width={555}
				icon={true}
			>
				<TextTopWrapper>
					<TextModalWrapper>
						<TextModalCustom dangerouslySetInnerHTML={{ __html: text }}></TextModalCustom>
					</TextModalWrapper>
					<TextModalWrapper>
						<TextModalCustom>{translations['modal__itemRef__timeline_action_activation_now_message_secondPart']}</TextModalCustom>
					</TextModalWrapper>
				</TextTopWrapper>
				<TextModalWrapperBottom>
					<TextModalRed>{translations['modal__itemRef__timeline_action_activation_now_message_thirdPart']}</TextModalRed>
				</TextModalWrapperBottom>

				<ButtonWrapper>
					<Button
						actionHandler={props.active.close}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={handleActiveItem}
						text={translations['modal__itemRef__timeline_action_activation_now_buttons_validate']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
		</ModalDeleteWrapper>
	)
}

ModalDelete.propTypes = {}

ModalDelete.defaultPropTypes = {}

export default ModalDelete
